import Styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

export const ShippingSection = Styled.div`
  margin-top: 32px;
  width: 100%;
  min-width: 0;
`;

export const ShippingTitle = Styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #1D1D1F;
  line-height: 1.5;
  margin-bottom: 8px;
`;

export const ShippingBox = Styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 9px;
  background: #F5F5F7;
  min-width: 0;
`;

export const ShippingBoxError = Styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 9px;
  background: #FDEBEC;
`;

export const ShippingInfoRow = Styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ShippingInfoText = Styled.span`
  flex: 1 0 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const ShippingText = Styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #1D1D1F;
  line-height: 1.5;
`;

export const ShippingAddress = Styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
  max-width: 100%;
`;

export const ChangeAddressLink = Styled.button`
  background: none;
  border: none;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: #000;
  text-overflow: ellipsis;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
  font-family: var(--font-family);
  margin-top: 16px;
`;

export const ReloadButton = Styled.button`
  background: none;
  border: none;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 400;
  color: #1D1D1F;
  cursor: pointer;
  font-family: var(--font-family);
`;

export const SkeletonLine = Styled.div`
  height: ${(p) => p.h || "16px"};
  width: ${(p) => p.w || "100%"};
  border-radius: 4px;
  background: #E5E5EA linear-gradient(
    90deg,
    rgba(229, 229, 234, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(229, 229, 234, 0) 100%
  ) no-repeat;
  background-size: 200px 100%;
  animation: ${shimmer} 1.2s infinite linear;
`;

export const PrimaryButton = Styled.button`
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: var(--button-border-radius);
  background-color: var(--button-primary-color, #1D1D1F);
  color: var(--button-secondary-color, #FFFFFF);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 16px;
  font-family: var(--font-family);

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
